const PropTypes = require('prop-types');
const React = require('react');
const UrlHelpers = require('components/shared/url_helpers.js');
const UiUtil = require('components/utils/ui.js');
const ErrorMessage = require('components/shared/error_message.jsx');
const { MobileDetection } = require('@reverbdotcom/discovery-ui');
const ShippingAddressFields = require('components/addresses/shipping_address_fields.jsx');

class AddressForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: props.formErrors,
      enabledSaveButton: true,
      showDeleteAddressConfirm: false,
    };
  }

  componentDidUpdate() {
    if (this.state.errorMessage) {
      if (MobileDetection.isMobileScreenWidth()) {
        UiUtil.scrollToElement(this.refs.errorMessage);
      }
    }
  }

  isCreatingNewAddress() {
    return this.props.addressId === undefined;
  }

  handleDeleteAddressConfirm() {
    Reverb.APIRequest.V3.destroy(
      UrlHelpers.myAddressesDeletePath(this.props.addressId)
    ).done(() => {
      this.props.handleUpdate();
    });
    return true;
  }

  handleSaveClick(addressProperties) {
    this.setState({ enabledSaveButton: false });

    return this.createOrUpdateAddress(addressProperties).done(() => {
      this.props.handleUpdate();
    }).error((response) => {
      const message = JSON.parse(response.responseText).message;
      this.setState({
        errorMessage: message,
        enabledSaveButton: true,
      });
    });
  }

  createOrUpdateAddress(addressProperties) {
    if (this.isCreatingNewAddress()) {
      return this.createNewAddress(addressProperties);
    }
    return this.updateExistingAddress(addressProperties);
  }

  addressApiParams(addressProperties) {
    return (
      {
        name: addressProperties.name,
        street_address: addressProperties.streetAddress,
        extended_address: addressProperties.extendedAddress,
        locality: addressProperties.locality,
        region: addressProperties.region,
        postal_code: addressProperties.postalCode,
        country_code: addressProperties.countryCode,
        phone: addressProperties.phone,
      }
    );
  }

  createNewAddress(addressProperties) {
    return (
      Reverb.APIRequest.V3.post(
        UrlHelpers.myAddressesCreatePath(),
        this.addressApiParams(addressProperties)
      )
    );
  }

  updateExistingAddress(addressProperties) {
    return (
      Reverb.APIRequest.V3.put(
        UrlHelpers.myAddressesUpdatePath(this.props.addressId),
        this.addressApiParams(addressProperties)
      )
    );
  }

  displayErrorMessage() {
    if (this.state.errorMessage) {
      return (
        <div ref="errorMessage">
          <ErrorMessage
            alertStyle="alert-error"
            message={this.state.errorMessage}
          />
        </div>
      );
    }
    return null;
  }

  handleCancelEditing() {
    if (!this.isCreatingNewAddress()) {
      this.props.cancelEditing();
    } else {
      this.props.handleUpdate();
    }
  }

  displayCancelEditLink() {
    if (this.props.displayCancelEditLink) {
      return (
        <a
          className="address-form__actions__tertiary"
          id="cancel_edit"
          onClick={() => this.handleCancelEditing()}
        >
          {I18n.t('js.addresses.addressForm.cancel')}
        </a>
      );
    }
    return null;
  }

  displayDeleteLink() {
    if (!this.isCreatingNewAddress()) {
      return this.displayDeleteOptionWithConfirm();
    }
    return null;
  }

  displayDeleteOptionWithConfirm() {
    if (this.state.showDeleteAddressConfirm) {
      return (
        <div className="address-form__actions__secondary">
          <span className="small mb-half">
            {I18n.t('js.addresses.addressForm.confirmDelete')}
          </span>
          <a
            className="ml-half"
            id="confirm_delete"
            onClick={() => this.handleDeleteAddressConfirm()}
          >
            {I18n.t('js.addresses.addressForm.yes')}
          </a>
          <a
            className="ml-half"
            onClick={() => this.setState({ showDeleteAddressConfirm: false })}
          >
            {I18n.t('js.addresses.addressForm.no')}
          </a>
        </div>
      );
    }
    return (
      <div className="address-form__actions__secondary">
        <a
          id="delete_address"
          onClick={() => this.setState({ showDeleteAddressConfirm: true })}
          className="color-red"
        >
          {I18n.t('js.addresses.addressForm.deleteAddress')}
        </a>
      </div>
    );
  }

  nameForInput(fieldName) {
    if (this.props.formObjectName) {
      return `${this.props.formObjectName}[${fieldName}]`;
    }
    return null;
  }

  render() {
    return (
      <div data-address-form="true">
        {this.displayErrorMessage()}
        <ShippingAddressFields
          name={this.props.name}
          streetAddress={this.props.streetAddress}
          extendedAddress={this.props.extendedAddress}
          locality={this.props.locality}
          region={this.props.region}
          postalCode={this.props.postalCode}
          countryCode={this.props.countryCode}
          phone={this.props.phone}
          countriesForSelect={this.props.countriesForSelect}
          nameForInput={(fieldName) => this.nameForInput(fieldName)}
          enabledSaveButton={this.state.enabledSaveButton}
          handleSaveClick={(addressProperties) => this.handleSaveClick(addressProperties)}
        >
          <div className="address-form__actions__options-wrapper">
            {this.displayCancelEditLink()}
            {this.displayDeleteLink()}
          </div>
        </ShippingAddressFields>
      </div>
    );
  }
}

AddressForm.propTypes = {
  addressId: PropTypes.string,
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  countriesForSelect: PropTypes.array.isRequired,
  cancelEditing: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  formObjectName: PropTypes.string,
  displayCancelEditLink: PropTypes.bool,
  formErrors: PropTypes.string,
};

module.exports = AddressForm;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/address_form.jsx